import {InjectionToken, Provider} from '@angular/core';
import {ActionReducerMap} from '@ngrx/store';
import {CustomTicketsActionTypes, CustomTicketsListActions} from '../actions/custom-ticket.action';
import {CustomTicketsListState, TICKETS} from '../custom-tickets-state';
import {StateUtils} from '@spartacus/core';
import {TicketWrapper} from "../../model/ticket.model";

export const initialState: TicketWrapper = {
  pagination: {},
  sorts: [],
  tickets: [],
};

export function ticketsReducer(
  state = initialState,
  action: CustomTicketsListActions,
): any {
  switch (action.type) {
    case CustomTicketsActionTypes.LOAD_TICKETS_FAIL: {
      return initialState;
    }
    case CustomTicketsActionTypes.LOAD_TICKETS_SUCCESS: {
      return action.payload ??  initialState;
    }
    case CustomTicketsActionTypes.LOAD_TICKET_FAIL: {
      return initialState;
    }
    case CustomTicketsActionTypes.LOAD_TICKET_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
    case CustomTicketsActionTypes.ADD_TICKET_FAIL: {
      return initialState;
    }
    case CustomTicketsActionTypes.ADD_TICKET_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
    case CustomTicketsActionTypes.LOAD_TICKETS_CATEGORY_FAIL: {
      return initialState;
    }
    case CustomTicketsActionTypes.LOAD_TICKETS_CATEGORY_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
    case CustomTicketsActionTypes.LOAD_TICKETS_COMPANY_CATEGORY_FAIL: {
      return initialState;
    }
    case CustomTicketsActionTypes.LOAD_TICKETS_COMPANY_CATEGORY_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
  }
  return state;
}




export function getTicketsReducers(): ActionReducerMap<CustomTicketsListState> {
  return {

    entities: StateUtils.loaderReducer<any>(
      TICKETS,
      ticketsReducer
    ),
  };
}

export const reducerTicketsToken: InjectionToken<ActionReducerMap<CustomTicketsListState>> = new InjectionToken<ActionReducerMap<CustomTicketsListState>>(
  'TicketsReducers',
);

export const reducerTicketsProvider: Provider = {
  provide: reducerTicketsToken,
  useFactory: getTicketsReducers,
};
